
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    PUTTBDFIFTEENPOINTS_ACTION,
    ALL_PUTTBDFIFTEENPOINTS,
    ADD_PUTTBDFIFTEENPOINTS,
    ALL_PUTTBDFIFTEENPUTTS,
    ADD_PUTTBDFIFTEENPUTTS,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Putt broadie Drill 15FT Actions
 */

    export const stdBDFifteenPoints = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:PUTTBDFIFTEENPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentputtbdfifteenpoint', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data;
                
                dispatch({ type: ALL_PUTTBDFIFTEENPOINTS, payload: alldata.data }); 
                return Promise.resolve(alldata);
            });
        
        }
    }

    export const addBDFifteenPoints = (student, startdate, enddate, data, sepmore) =>{
        
        var payload={
            "startdate":startdate,
            "enddate":enddate,
            "totval":1,
            "student":student,
            "shtot_1":sepmore,
        }
        

        for (let i = 0; i<sepmore; i++) {   
           
            var putdate='puttdate_'+i;            
            var putdateval=data.target[putdate].value;
            var putpoint='noputt_'+i;            
            var putpointval=data.target[putpoint].value;                   
            
            var adval=i+1;            
            var dateadd='puttdate_1_'+adval;  
            var puttadd='noputt_1_'+adval;             
           
            payload[dateadd]=putdateval;
            payload[puttadd]=putpointval;          
    
        }        

        return (dispatch) => { 
            dispatch({ type:PUTTBDFIFTEENPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addputtbdfifteenpoint', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                   
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_PUTTBDFIFTEENPOINTS});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const stdBDFifteenPutts = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:PUTTBDFIFTEENPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentputtbdfifteenputt', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data;
                
                dispatch({ type: ALL_PUTTBDFIFTEENPUTTS, payload: alldata.data }); 
                return Promise.resolve(alldata);
            });
        
        }
    }

    export const addBDFifteenPutts = (student, startdate, enddate, data, sepmore) =>{
        
        var payload={
            "startdate":startdate,
            "enddate":enddate,
            "totval":1,
            "student":student,
            "shtot_1":sepmore,
        }
        

        for (let i = 0; i<sepmore; i++) {   
           
            var putdate='puttdate_'+i;            
            var putdateval=data.target[putdate].value;
            var putpoint='noputt_'+i;            
            var putpointval=data.target[putpoint].value;                   
            
            var adval=i+1;            
            var dateadd='puttdate_1_'+adval;  
            var puttadd='noputt_1_'+adval;             
           
            payload[dateadd]=putdateval;
            payload[puttadd]=putpointval;          
    
        }        

        return (dispatch) => { 
            dispatch({ type:PUTTBDFIFTEENPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addputtbdfifteenputt', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                   
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_PUTTBDFIFTEENPUTTS});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


